module.exports = __webpack_public_path__ + "quote.png?d764afef9960015d519f862aa124badc";